  //#ffda00
  var sjYellow=["S1P","S1","S2","S3","S4","S5","SB","4X42D","4X42F","4X43C","4X44C","2131X","3243X","2131X","4132X","3121X","4121X","4131X"];
  //#00a9e0
   var sjBlue=["O1","O2","O3","O4","O5","OB","PB"];
  //#da291c
   var sjRed=["TROOPER","TACTIC","ARMOUR","SHARK","DRAGON","KOMODO","DUNE"];
    //#ed8b00
   var sjOrange=["JACKSGRIP"];

/*executes when HTML-Document is loaded and DOM is ready*/
$(document).ready(function() {

     /**
     *  Variant selection changed
     *  data-variant-toggle=""
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	    // $('[data-variant-toggle]').hide(0);
	    // $('[data-variant-toggle="'+variant.id+'"]').show(0);
	  });
});

/*executes when complete page is fully loaded, including all frames, objects and images*/
$(window).on('load', function (e) {  
  $("h1,h2,h3,h4,h5,h6,a").each(function( i ) {
    sjColorReplace(this,sjYellow,"#ffda00","#000");
    sjColorReplace(this,sjBlue,"#00a9e0","#fff");
    sjColorReplaceTactic(this,sjRed,"#da291c","#fff");
    sjColorReplaceTactic(this,sjOrange,"#ed8b00","#fff");
  });
    /*sjYellow.forEach((item, j) => {
      var sjreplace = new RegExp("( "+item+")(?![^<]*>|[^<>]*</)","ig");
      this.innerHTML=this.innerHTML.replace(sjreplace," <span style='background:#ffda00;'> "+item+" </span>");
  });*/
  //})
});

function sjColorReplace (dis, colorArr, tColor,fColor){
  dis=sjDeepestChild(dis);
  var sjreplace = new RegExp(" ("+colorArr.join("|")+")(?![^<]*>|[^<>]*</)","ig");
  dis.innerHTML=dis.innerHTML.replace(/\n/ig,"").replace(sjreplace,`&nbsp; <span style='background:${tColor};color:${fColor};'>&nbsp;$1&nbsp;</span>`);
}

function sjColorReplaceTactic (dis, colorArr, tColor,fColor){
  var sjreplace = new RegExp(colorArr.join("|"),"ig");
  if (dis.innerText.search(sjreplace)>-1) {
    try {
      var span=sjDeepestChild(dis.getElementsByTagName("span")[0]);
      span.style.background=tColor;
      span.style.color=fColor;
    } catch (e) {}
  }
}

function sjDeepestChild(element) {
  while (element.firstElementChild) {
    element = (element).firstElementChild;
  }
  return element;
}



/*csv to array*/
function sjCsvToArray(text) {
    let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
    for (l of text) {
        if ('"' === l) {
            if (s && l === p) row[i] += l;
            s = !s;
        } else if (',' === l && s) l = row[++i] = '';
        else if ('\n' === l && s) {
            if ('\r' === p) row[i] = row[i].slice(0, -1);
            row = ret[++r] = [l = '']; i = 0;
        } else row[i] += l;
        p = l;
    }
    return ret;
}